export default [
    {
        path: '/admin/working-hours',
        name: 'working-hours',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/working-hours/index.vue')
    }
]
